import React, { Component } from 'react';
import {storyTemplates} from '../../utils/constants'
import { connect } from 'react-redux';
import * as actionCreators from '../../modules/actions/index';
import {withRouter} from 'react-router-dom';
import { isMobile } from '../../utils/deviceInfo';
import FooterBar from '../../components/FooterBar/FooterBar';

class StoriesTypes extends Component {

	constructor(props) {
    super(props);
			this.state = {
		  }
    }

		componentDidMount(){
			if(isMobile)
			this.props.updateNavBar({
				title: null,
				hasBack: true,
				backTo: '/home/stories',
				backButton: '<b>Cancel</b>',
				showNotification: false,
				isBreadCrumbs: false,
				className: 'no-separator'
			});
		}


	render() {
		console.log(this.props)
  		return (
				<div>
						<div className="templatePara1"> What do you want to share today? </div>
						<div className="ml-3 stories_template_items_container storytypes-mobile-list">
							{ storyTemplates.map( (e, idx)=> {
								return (
									<div className="row" key={idx} onClick={() => this.props.history.push(`/home/stories/create/${e._id}`)}>
										<div className={`storyContainer ${isMobile && 'mb-4'} `} >
											<div className="storyTemplate" style={{"backgroundColor":e.color, "border":e.border}} >
												<img src={e.image} className="templateImage"/>

											</div>
											<div className="share-title">{e.name}</div>
											<div className="right-arrow">
												<i className="chart-item-menu flaticon-down-arrow-2 right-arrow-icon"></i>
											</div>
										</div>
									</div>
								)
							})}
						</div>
						{ isMobile && <FooterBar {...this.props}/> }
				</div>
			)
	}
}

const mapDispatchToProps = dispatch => {
	return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(StoriesTypes));
